import { useTheme } from "next-themes";
import { useMemo } from "react";
import { cn } from "@project/ui";
import { useI18n } from "@apps/dashboard/contexts/I18nContext";

type Mode = "light" | "dark" | "system";

export function ThemeModeControl(): JSX.Element {
  const { t } = useI18n();
  const { theme, setTheme } = useTheme();

  const options = useMemo(
    () =>
      [
        { value: "light", label: t("common.theme.light") },
        { value: "dark", label: t("common.theme.dark") },
        { value: "system", label: t("common.theme.system") },
      ] as const satisfies ReadonlyArray<{ value: Mode; label: string }>,
    [t],
  );

  return (
    <div className="rounded-2xl border border-outline-variant/20 bg-surface-container-low p-4">
      <p className="font-label text-xs uppercase tracking-widest text-on-surface-variant">{t("common.theme.label")}</p>
      <div className="mt-3 grid grid-cols-3 gap-2">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => setTheme(option.value)}
            className={cn(
              "rounded-lg px-3 py-2 text-sm font-semibold transition-colors",
              theme === option.value
                ? "bg-primary text-on-primary"
                : "bg-surface-container-high text-on-surface hover:bg-surface-container-highest",
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
